/* mm-spec-table v1.6 (2026-10-12: natural two-stone pieces show one block per diamond, Diamond 1 · Round and Diamond 2 · Pear, instead of joined rows; v1.5 2026-10-12: window.mmSpec.fixed() for fixed pieces with a hidden natural twin, grade panel reads ranges like G–H and VS–SI; v1.4 2026-10-12: natural diamond mode via window.mmSpec for snippets/mm-natural-diamond.liquid; v1.3 2026-09-30: center diamond size shown as "Approx."; v1.2 Piece Passport (i) by variant; v1.1 variant-level Setting; v1.0 same day), Modern Mangal product page spec table.
   Pairs with snippets/mm-spec-table.liquid + assets/mm-spec-table.css.
   Fills the variant-level rows for the selected variant, hides empty rows and empty columns,
   builds the grading report row (brief 5.1) and the Gemstones block, and runs the (i) help popovers. */
(() => {
  const root = document.querySelector('[data-mm-spec]');
  const dataEl = root && root.querySelector('[data-mm-spec-json]');
  if (!root || !dataEl || root.dataset.mmReady) return;
  root.dataset.mmReady = '1';

  let cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
  const H = cfg.help || {};
  const V = cfg.variants || {};
  const main = document.querySelector('[id^="MainProduct-"]') || document;

  // ---------- formatting ----------
  const has = (x) => x !== null && x !== undefined && String(x).trim() !== '';
  const num = (x) => { const n = parseFloat(x); return isNaN(n) ? null : n; };
  // values are stored already rounded half-down to 2 decimals; only trim trailing zeros here
  const ct = (x) => { const n = num(x); return n === null ? '' : String(Math.round(n * 100) / 100) + ' ct'; };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // ---------- (i) help ----------
  let uid = 0;
  function helpBtn(text, label) {
    if (!has(text)) return '';
    const id = 'mm-spec-tip-' + (++uid);
    return '<button type="button" class="mm-spec__i" aria-expanded="false" aria-controls="' + id + '" aria-label="About ' + esc(label) + '">i</button>' +
      '<span class="mm-spec__tip" id="' + id + '" role="tooltip" hidden>' + esc(text) + '</span>';
  }
  function setHelp(row, text) {
    const slot = row.querySelector('[data-mm-help]');
    if (!slot) return;
    const label = ((row.querySelector('dt') || row).firstChild || {}).textContent.trim();
    const html = helpBtn(text, label);
    if (slot.dataset.mmHtml !== html) { slot.innerHTML = html; slot.dataset.mmHtml = html; }
  }
  // static rows (Color, Clarity) carry their key in data-mm-help="key"
  root.querySelectorAll('[data-mm-help]:not(:empty), [data-mm-help]').forEach((slot) => {
    const key = slot.getAttribute('data-mm-help');
    if (key) setHelp(slot.closest('.mm-spec__row'), H[key]);
  });

  function closeTips(except) {
    root.querySelectorAll('.mm-spec__i[aria-expanded="true"]').forEach((b) => {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      const t = document.getElementById(b.getAttribute('aria-controls'));
      if (t) t.hidden = true;
    });
  }
  root.addEventListener('click', (e) => {
    const b = e.target.closest('.mm-spec__i');
    if (!b) return;
    e.preventDefault();
    const open = b.getAttribute('aria-expanded') !== 'true';
    closeTips(b);
    b.setAttribute('aria-expanded', String(open));
    const t = document.getElementById(b.getAttribute('aria-controls'));
    if (t) t.hidden = !open;
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('.mm-spec__i, .mm-spec__tip')) closeTips(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeTips(); });

  // ---------- rows ----------
  const row = (k) => root.querySelector('[data-mm-row="' + k + '"]');
  function put(k, html, help) {
    const r = row(k);
    if (!r) return;
    const on = has(html);
    r.hidden = !on;
    const dd = r.querySelector('[data-mm-val]');
    if (dd && dd.innerHTML !== (on ? html : '')) dd.innerHTML = on ? html : '';
    if (on) setHelp(r, help);
  }

  // grading row: value + help key are worked out in Liquid (brief 5.1); raw stone counts are not on the page
  function grading(v) {
    const g = Array.isArray(v.grade) ? v.grade : [];
    if (!has(g[0])) return ['', ''];
    let t = H[g[1]] || (g[1] === 'grading_lab_selected_plural' ? H.grading_lab_selected : '');
    if (g[1] === 'grading_A') t = has(g[2]) && has(t) ? t.replace('{ct}', String(Math.round(num(g[2]) * 100) / 100)) : '';
    return [esc(g[0]), t];
  }

  function render(v) {
    if (!v) return;
    const gems = Array.isArray(v.gems) ? v.gems.filter((g) => g && has(g.stone)) : [];
    const gemsWithCt = gems.some((g) => num(g.ctw) !== null);

    put('metal', has(v.metal) ? esc(v.metal) : '');
    put('total_ctw', has(v.tot) ? ct(v.tot) + (gemsWithCt ? ' (all stones)' : '') : '');

    const base = num(v.lenBase);
    const lenHelp = cfg.tpl === 'bracelet' ? H.bracelet_length : base === 16 ? H.length_16 : base === 18 ? H.length_18 : '';
    put('length', has(v.len) ? esc(v.len) : '', lenHelp);

    const rs = row('ring_size');
    if (rs) put('ring_size', has(v.o && v.o[Number(rs.dataset.opt)]) ? esc(v.o[Number(rs.dataset.opt)]) : '');

    const g = grading(v);
    put('grading', g[0], g[1]);
    put('sku', has(v.sku) ? esc(v.sku) : '');
    // Piece Passport: always shown; the (i) says "certification" only when this variant comes with an IGI report
    const pr = row('passport');
    if (pr) { pr.hidden = false; setHelp(pr, (num(v.cert) || 0) > 0 ? H.passport_certified : H.passport); }

    // typical size for this carat and shape, not a measurement of the exact stone, so it reads as approximate
    put('centre_mm', has(v.centre) ? (/^approx/i.test(String(v.centre)) ? '' : 'Approx. ') + esc(v.centre) : '');
    // Setting: the variant's own value (solitaires: prong count for this carat), else the product's
    const sr = row('setting');
    const sett = has(v.setting) ? v.setting : sr ? sr.dataset.productVal : '';
    put('setting', has(sett) ? esc(sett) : '');
    put('diamond_ctw', has(v.dia) && gemsWithCt ? ct(v.dia) : '');

    const ps = row('pendant_style');
    const pend = has(v.pend) ? v.pend : ps ? ps.dataset.productVal : '';
    const pk = String(pend || '').toLowerCase();
    put('pendant_style', has(pend) ? esc(pend) : '', pk === 'bail' ? H.pendant_bail : pk === 'fixed' ? H.pendant_fixed : '');

    put('inscription', has(v.insc) ? esc(v.insc) : '');

    const cr = row('chain');
    const ctype = cr ? cr.dataset.productVal : '';
    const mm = num(v.chainMm);
    const chain = [has(ctype) ? ctype : '', mm !== null ? mm + ' mm' : ''].filter(Boolean).join(', ');
    put('chain', chain ? esc(chain) : '');

    // Gemstones block: name and carat only, no counts
    const box = root.querySelector('[data-mm-gems]');
    const list = root.querySelector('[data-mm-gems-list]');
    if (box && list) {
      const html = gems.map((x) => '<div class="mm-spec__row"><dt>' + esc(x.stone) + '</dt><dd>' + (num(x.ctw) !== null ? ct(x.ctw) : '') + '</dd></div>').join('');
      if (list.innerHTML !== html) list.innerHTML = html;
      box.hidden = !gems.length;
    }

    // a column with no visible rows is hidden
    root.querySelectorAll('[data-mm-col]').forEach((col) => {
      const any = [...col.querySelectorAll('.mm-spec__row')].some((r) => !r.hidden && !r.closest('[hidden]'));
      col.hidden = !any;
    });
  }

  // ---------- which variant is selected ----------
  const picker = () => main.querySelector('variant-selects, variant-radios');
  function currentId() {
    const p = picker();
    if (p) {
      const sel = [...p.querySelectorAll('select')].map((s) => s.value);
      const checked = [...p.querySelectorAll('input[type="radio"]:checked')].map((i) => i.value);
      const o = sel.length ? sel : checked;
      if (o.length) {
        const hit = Object.keys(V).find((id) => V[id].o && V[id].o.length === o.length && V[id].o.every((x, i) => x === o[i]));
        if (hit) return hit;
      }
    }
    const u = new URLSearchParams(location.search).get('variant');
    if (u && V[u]) return u;
    const f = main.querySelector('form[action*="/cart/add"] [name="id"]');
    if (f && V[f.value]) return f.value;
    return String(cfg.current);
  }
  let last = null;
  const update = (id) => {
    const k = id && V[String(id)] ? String(id) : currentId();
    if (k === last) return;
    last = k;
    render(V[k]);
  if (NAT) applyNat(); else if (FIX) applyFix();
  };

  document.addEventListener('variant:change', (e) => {
    const d = e && e.detail;
    const id = d && ((d.variant && d.variant.id) || d.id);
    setTimeout(() => update(id), 0);
  });
  document.addEventListener('change', (e) => {
    if (e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(() => update(), 0);
  });
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
    try { window.subscribe(window.PUB_SUB_EVENTS.variantChange, (ev) => { const id = ev && ev.data && ev.data.variant && ev.data.variant.id; update(id); }); } catch (e) {}
  }
  window.addEventListener('popstate', () => setTimeout(() => update(), 0));

  // "Full details" opens the Details drop-down (theme accordion) before scrolling to it
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-mm-fulldetails]')) return;
    const item = root.closest('.about__accordion-item');
    const desc = item && item.querySelector('.about__accordion-description');
    const toggle = item && item.querySelector('.about__accordion-toggle');
    if (toggle && desc && desc.offsetHeight < 2) toggle.click();
  }, true);

  // ---------- v1.4 natural diamond mode (snippets/mm-natural-diamond.liquid) ----------
  // window.mmSpec.natural({ done, stones }) shows the chosen natural stone in the stone rows,
  // window.mmSpec.lab() puts the lab values back. Re-applied after every variant re-render.
  let NAT = null;
  let FIX = null; // v1.5 fixed pieces: { color, clarity, sku }
  const PENDING = 'Choose your diamond';
  const NAT_CODES = { '3Q': 'N1', P5: 'N2', QE: 'N3' };
  const POL = { EX: 'Excellent', ID: 'Excellent', EIGHTX: 'Excellent', VG: 'Very Good', GD: 'Good', G: 'Good', F: 'Fair', FR: 'Fair', P: 'Poor' };
  // same rule as the mm-nivoda Worker: natural code + the lab SKU's characters 3 to 7 + "-NAT"
  const natSku = (sku) => { const s = String(sku || '').trim().split(/\s+/)[0]; const k = NAT_CODES[s.slice(0, 2)]; return k && s.length >= 7 ? k + s.slice(2, 7) + '-NAT' : ''; };
  const statRow = (label) => [...root.querySelectorAll('.mm-spec__row:not([data-mm-row])')].find((r) => {
    const dt = r.querySelector('dt');
    return dt && String((dt.firstChild && dt.firstChild.textContent) || '').trim().toLowerCase() === label;
  });
  function natSet(r, html) {
    if (!r) return;
    const dd = r.querySelector('dd'); if (!dd) return;
    if (r.dataset.mmNatOrig == null) { r.dataset.mmNatOrig = dd.innerHTML; r.dataset.mmNatHid = r.hidden ? '1' : ''; }
    if (dd.innerHTML !== html) dd.innerHTML = html;
    r.hidden = false;
  }
  function natRestore(r) {
    if (!r || r.dataset.mmNatOrig == null) return;
    const dd = r.querySelector('dd'); if (dd) dd.innerHTML = r.dataset.mmNatOrig;
    r.hidden = !!r.dataset.mmNatHid;
    delete r.dataset.mmNatOrig; delete r.dataset.mmNatHid;
  }
  const two = (n) => (Math.round(Number(n) * 100) / 100).toFixed(2) + ' ct';
  function natHide(r) {
    if (!r) return;
    const dd = r.querySelector('dd');
    if (r.dataset.mmNatOrig == null) { r.dataset.mmNatOrig = dd ? dd.innerHTML : ''; r.dataset.mmNatHid = r.hidden ? '1' : ''; }
    r.hidden = true;
  }
  const iBtn = (k) => '<button type="button" class="mm-spec__i" aria-label="About ' + k + '">i</button><span class="mm-spec__tip mmgp-mini" hidden aria-hidden="true"></span>';
  const giaA = (s) => s.reportUrl ? 'GIA report <a href="' + esc(s.reportUrl) + '" target="_blank" rel="noopener">' + esc(s.certNumber) + '</a>' : 'GIA report';
  // v1.6: two-stone pieces show one block per diamond (Diamond 1 · Round, Diamond 2 · Pear), like a side-stone block
  function stoneBlocks(P) {
    return P.map((s, i) => {
      const shape = String(s.shape || '').toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
      const rows = [
        ['Carat weight', two(s.carat)],
        ['Color' + iBtn('color'), esc(s.color)],
        ['Clarity' + iBtn('clarity'), esc(s.clarity)],
        String(s.shape).toUpperCase() === 'ROUND' && s.cut ? ['Cut', esc(POL[String(s.cut).toUpperCase()] || s.cut)] : null,
        s.polish ? ['Polish' + iBtn('polish'), esc(POL[String(s.polish).toUpperCase()] || s.polish)] : null,
        ['Grading report', giaA(s)]
      ].filter(Boolean);
      return '<div class="mm-spec__gems" data-mm-natstone><h4 class="mm-spec__h mm-spec__h--sub">Diamond ' + (i + 1) + ' · ' + esc(shape) + '</h4><dl class="mm-spec__dl">' +
        rows.map((r) => '<div class="mm-spec__row"><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd></div>').join('') + '</dl></div>';
    }).join('');
  }
  function applyNat() {
    if (!NAT) return;
    const P = NAT.done ? (NAT.stones || []) : [];
    const v = V[last] || {};
    root.querySelectorAll('[data-mm-natstone]').forEach((e) => e.remove());
    natSet(statRow('diamond'), 'Natural diamond');
    const gems = Array.isArray(v.gems) ? v.gems.filter((g) => g && has(g.stone)) : [];
    if (P.length && !gems.length) put('total_ctw', two(P.reduce((a, s) => a + Number(s.carat), 0)));
    if (P.length > 1) {
      // each diamond in its own block; the shared rows step aside
      ['diamond cut', 'color', 'clarity', 'polish'].forEach((l) => natHide(statRow(l)));
      natHide(row('diamond_ctw'));
      put('grading', 'GIA report for each diamond', '');
      const dr = statRow('diamond'), col = dr && dr.closest('[data-mm-col]');
      const dl = col && col.querySelector('.mm-spec__dl');
      if (dl) dl.insertAdjacentHTML('afterend', stoneBlocks(P));
    } else {
      const s = P[0];
      natSet(statRow('color'), s ? esc(s.color) : PENDING);
      natSet(statRow('clarity'), s ? esc(s.clarity) : PENDING);
      const pol = statRow('polish');
      if (pol) natSet(pol, s ? esc(POL[String(s.polish || '').toUpperCase()] || s.polish || '') : PENDING);
      // the Diamond cut row names the shape (Round, Emerald), so it stays as it is
      put('diamond_ctw', s ? esc(two(s.carat)) : PENDING);
      put('grading', s ? giaA(s) : 'GIA report included', '');
    }
    const ns = natSku(v.sku);
    put('sku', ns ? esc(ns) : '');
    const pr = row('passport');
    if (pr) setHelp(pr, H.passport_certified || H.passport);
    root.querySelectorAll('[data-mm-col]').forEach((col) => {
      const any = [...col.querySelectorAll('.mm-spec__row')].some((r) => !r.hidden && !r.closest('[hidden]'));
      col.hidden = !any;
    });
    if (typeof window.mmGradeRefresh === 'function') window.mmGradeRefresh();
  }
  // v1.5: fixed pieces (snippets/mm-natural-twin.liquid). Stone count and carat stay as the lab piece; grades, origin and SKU change.
  function applyFix() {
    if (!FIX) return;
    natSet(statRow('diamond'), 'Natural diamond');
    if (has(FIX.color)) natSet(statRow('color'), esc(FIX.color));
    if (has(FIX.clarity)) natSet(statRow('clarity'), esc(FIX.clarity));
    put('sku', has(FIX.sku) ? esc(FIX.sku) : '');
    const gr = row('grading');
    if (gr && has(FIX.gradingHelp)) setHelp(gr, FIX.gradingHelp);
    root.querySelectorAll('[data-mm-col]').forEach((col) => {
      const any = [...col.querySelectorAll('.mm-spec__row')].some((r) => !r.hidden && !r.closest('[hidden]'));
      col.hidden = !any;
    });
    if (typeof window.mmGradeRefresh === 'function') window.mmGradeRefresh();
  }
  window.mmSpec = {
    natural(state) { FIX = null; NAT = state || { done: false, stones: [] }; if (last == null) update(); applyNat(); },
    fixed(state) { NAT = null; FIX = state || {}; root.querySelectorAll('[data-mm-natstone]').forEach((e) => e.remove()); if (last == null) update(); applyFix(); },
    lab() {
      if (!NAT && !FIX) return;
      NAT = null; FIX = null;
      root.querySelectorAll('[data-mm-natstone]').forEach((e) => e.remove());
      root.querySelectorAll('.mm-spec__row[data-mm-nat-orig]').forEach(natRestore);
      const k = last; last = null; update(k);
      if (typeof window.mmGradeRefresh === 'function') window.mmGradeRefresh();
    }
  };

  update();
  document.dispatchEvent(new CustomEvent('mm:spec-ready'));
})();

/* ===== mm-grade-panel v1.2 (2026-10-09; v1.2 lab-grown or natural wording from the Diamond row, grades marked from this piece's value; v1.1 hover card shows the scale, 13 px tips, space before the (i)): Color / Clarity / Polish (i) open a side panel with the grading scale.
   Appended to mm-spec-table.js. Takes over the (i) on the Color and Clarity rows, adds one to the Polish row.
   Phones: bottom sheet. Laptops: right-hand drawer. Grade tiles are tappable and explain each grade. ===== */
(() => {
  const spec = document.querySelector('[data-mm-spec]');
  if (!spec || spec.dataset.mmGrades) return;
  spec.dataset.mmGrades = '1';

  const G = {
    color: {
      title: 'Color', key: 'color',
      body: 'Color grades how much warmth a diamond shows. The scale starts at D, with no color at all, and moves through the alphabet as a faint yellow appears. A whiter stone looks brighter in any light.',
      grades: ['J', 'I', 'H', 'G', 'F', 'E', 'D'], min: 'E',
      bands: [['Near colorless', 4], ['Colorless', 3]],
      tips: {
        J: 'Near colorless. A faint warmth shows, most of all in white gold.',
        I: 'Near colorless. A slight warmth you may notice next to a whiter stone.',
        H: 'Near colorless. Looks white face up, with a trace of warmth from the side.',
        G: 'Near colorless. Hard to tell from colorless without a comparison stone.',
        F: 'Colorless. A grader finds a trace of color only against a master stone.',
        E: 'Colorless. Our minimum. Icy white to the eye, in every metal.',
        D: 'Colorless. The highest grade, with no color at all.'
      },
      promise: { lab: 'Every lab-grown diamond we set is E color or better, colorless to the eye.' }, each: 'color'
    },
    clarity: {
      title: 'Clarity', key: 'clarity',
      body: 'Clarity grades the tiny marks inside a diamond and on its surface. {origin} Graders look for them under 10x magnification.',
      grades: ['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF', 'FL'], min: 'VS1',
      bands: [['Slightly included', 2], ['Very slightly included', 2], ['Very very slightly', 2], ['Flawless', 2]],
      tips: {
        SI2: 'Slightly included. Marks are easy to see at 10x and can show to the eye.',
        SI1: 'Slightly included. Marks are noticeable at 10x and sometimes to the eye.',
        VS2: 'Very slightly included. Minor marks at 10x, usually not visible to the eye.',
        VS1: 'Very slightly included. Our minimum. Minor marks only a grader finds at 10x, nothing visible to the eye.',
        VVS2: 'Very very slightly included. Marks are very hard to find at 10x.',
        VVS1: 'Very very slightly included. Marks are extremely hard to find, even for a grader at 10x.',
        IF: 'Internally flawless. No marks inside, only tiny surface marks at 10x.',
        FL: 'Flawless. No marks inside or on the surface at 10x.'
      },
      promise: { lab: 'Every lab-grown diamond we set is VS1 clarity or better, with nothing visible to the eye.' }, each: 'clarity'
    },
    polish: {
      title: 'Polish', key: 'polish',
      body: 'Polish grades how smooth each facet is after cutting. Smoother facets reflect light cleanly, so the stone looks crisp instead of hazy.',
      grades: ['Good', 'Very Good', 'Excellent'], min: 'Excellent',
      bands: [],
      tips: {
        Good: 'Small polish marks a grader can see at 10x.',
        'Very Good': 'Faint polish marks that are hard to find at 10x.',
        Excellent: 'No polish marks visible at 10x. The top grade, and the one we set.'
      },
      promise: { lab: 'Every lab-grown diamond we set has Excellent polish.' }, each: 'polish'
    }
  };

  /* round brilliant seen from above; tint and inclusion dots vary by grade */
  const FACETS = '<path d="M20 3 32 8l5 12-5 12-12 5-12-5-5-12 5-12Z" /><path d="M20 3v8M32 8l-6 6M37 20h-8M32 32l-6-6M20 37v-8M8 32l6-6M3 20h8M8 8l6 6" /><path d="M20 11l6 3 3 6-3 6-6 3-6-3-3-6 3-6Z" />';
  const tint = ['#F2DFAE', '#F5E6BF', '#F7ECCF', '#F9F1DD', '#FBF6EA', '#FDFAF4', '#FFFFFF'];
  const dots = {
    SI2: [[14, 15, 1.6], [25, 24, 1.4], [18, 27, 1.2], [27, 13, 1]], SI1: [[15, 16, 1.4], [25, 24, 1.2], [19, 27, 1]],
    VS2: [[16, 17, 1.1], [24, 24, .9]], VS1: [[17, 18, .9], [24, 23, .7]], VVS2: [[18, 19, .6]], VVS1: [[22, 21, .45]], IF: [], FL: []
  };
  function gem(kind, g, i) {
    let fill = '#FFFFFF', extra = '', op = 1;
    if (kind === 'color') fill = tint[i];
    if (kind === 'clarity') extra = (dots[g] || []).map((d) => '<circle cx="' + d[0] + '" cy="' + d[1] + '" r="' + d[2] + '" fill="#0C1C2E" stroke="none"/>').join('');
    if (kind === 'polish') op = [0.35, 0.65, 1][i];
    return '<svg viewBox="0 0 40 40" aria-hidden="true"><g fill="' + fill + '" stroke="#96765A" stroke-width=".8" stroke-opacity="' + op + '" stroke-linejoin="round">' + FACETS + '</g>' + extra + '</svg>';
  }

  /* lab-grown or natural, from the Diamond row of this product; wording and standards follow it */
  const ORIGIN_LINE = {
    lab: 'Lab-grown diamonds form them too, as the crystal grows.',
    natural: 'Natural diamonds form them deep in the earth, as the crystal grows.'
  };
  const originOf = () => {
    const r = [].slice.call(spec.querySelectorAll('.mm-spec__row')).find((x) => /^diamond\b/i.test(((x.querySelector('dt') || {}).textContent || '').trim()) && !/carat|cut/i.test((x.querySelector('dt') || {}).textContent));
    const v = ((r && r.querySelector('dd')) || {}).textContent || '';
    return /natural|mined|earth/i.test(v) ? 'natural' : 'lab';
  };
  let ORIGIN = originOf();
  // v1.5: a range like G–H or VS–SI (fixed natural pieces); VS / SI / VVS cover both of their grades
  const RANGE = { VS: ['VS2', 'VS1'], SI: ['SI2', 'SI1'], VVS: ['VVS2', 'VVS1'] };
  const rangeOf = (d, raw) => {
    const m = String(raw).match(/^([A-Za-z0-9 ]+?)\s*(?:–|-|to)\s*([A-Za-z0-9 ]+)$/);
    if (!m) return null;
    const ex = (g) => RANGE[g.trim().toUpperCase()] || [g.trim().toUpperCase()];
    const idx = ex(m[1]).concat(ex(m[2])).map((g) => d.grades.indexOf(g));
    if (idx.some((i) => i < 0)) return null;
    return [Math.min.apply(null, idx), Math.max.apply(null, idx)];
  }; // v1.4: re-read when natural mode changes the Diamond row
  const tipOf = (d, g) => d.promise[ORIGIN] ? d.tips[g] : d.tips[g].replace(' Our minimum.', '').replace(', and the one we set', '');
  function info(kind, value) {
    const d = G[kind];
    const raw = String(value || '').trim();
    const rg = rangeOf(d, raw);
    if (rg) return { d: d, raw: raw, sel: d.grades[rg[1]], minI: rg[0], maxI: rg[1], promise: 'Every diamond in this piece is ' + raw.replace(/\s*[–-]\s*/, ' to ') + ' ' + d.each + '.', body: d.body.replace('{origin}', ORIGIN_LINE[ORIGIN]) };
    const base = raw.replace(/\+$/, '').trim();
    const known = d.grades.indexOf(base) >= 0;
    const min = d.promise[ORIGIN] ? d.min : (known ? base : d.min);
    const sel = known ? base : min;
    const plus = /\+$/.test(raw);
    const promise = d.promise[ORIGIN] || (!known ? 'Choose your diamond to see its ' + d.each + ' grade.' : d.each === 'polish' ? 'This diamond has ' + base + ' polish.' : 'This diamond is ' + base + ' ' + d.each + (plus ? ' or better.' : '.'));
    return { d: d, raw: raw, sel: sel, minI: d.grades.indexOf(min), maxI: d.grades.length - 1, promise: promise, body: d.body.replace('{origin}', ORIGIN_LINE[ORIGIN]) };
  }

  const css = ".mmgp{position:fixed;inset:0;z-index:2147483000;display:none} .mmgp.is-open{display:block} .mmgp__bg{position:absolute;inset:0;background:rgba(12,28,46,.42);opacity:0;transition:opacity .25s} .mmgp.is-in .mmgp__bg{opacity:1} .mmgp__p{position:absolute;background:var(--mm-chalk,#F8F6F2);color:var(--mm-navy,#0C1C2E);font-family:var(--mm-sans,Montserrat,Arial,sans-serif);font-size:15px;line-height:1.65;overflow-y:auto;overscroll-behavior:contain;display:grid;gap:20px;align-content:start;padding:28px 24px 32px;box-shadow:0 20px 60px -20px rgba(12,28,46,.5);transition:transform .3s cubic-bezier(.2,.7,.2,1)} @media (max-width:749px){.mmgp__p{left:0;right:0;bottom:0;max-height:88vh;transform:translateY(100%);padding-bottom:calc(32px + env(safe-area-inset-bottom,0px))}.mmgp.is-in .mmgp__p{transform:none}} @media (min-width:750px){.mmgp__p{top:0;right:0;bottom:0;width:min(460px,100vw);padding:40px 36px;transform:translateX(100%)}.mmgp.is-in .mmgp__p{transform:none}} @media (prefers-reduced-motion:reduce){.mmgp__bg,.mmgp__p{transition:none}} .mmgp__x{position:absolute;top:12px;right:12px;width:40px;height:40px;border:0;background:none;color:inherit;font:300 28px/1 var(--mm-sans,Arial);cursor:pointer} .mmgp__eye{font:500 11px/1.4 var(--mm-sans,Arial);letter-spacing:.2em;text-transform:uppercase;color:var(--mm-mocha,#6B5341);margin:0} .mmgp h2{font-family:var(--mm-serif,Georgia,serif);font-weight:400;font-size:32px;line-height:1.1;margin:-8px 0 0;color:inherit;letter-spacing:0;text-transform:none} .mmgp p{margin:0;color:inherit} .mmgp__this{display:flex;align-items:baseline;gap:10px;padding:14px 0;border-top:1px solid var(--mm-line,rgba(150,118,90,.22));border-bottom:1px solid var(--mm-line,rgba(150,118,90,.22))} .mmgp__this span{font:500 11px/1.4 var(--mm-sans,Arial);letter-spacing:.16em;text-transform:uppercase;color:var(--mm-mocha,#6B5341)} .mmgp__this b{font-family:var(--mm-serif,Georgia,serif);font-weight:500;font-size:22px} .mmgp__scale{display:grid;gap:8px} .mmgp__row{display:grid;grid-auto-flow:column;grid-auto-columns:1fr;gap:2px} .mmgp__g{appearance:none;border:0;background:none;padding:6px 0 8px;display:grid;justify-items:center;gap:6px;cursor:pointer;color:var(--mm-accent,#96765A);font:500 11px/1 var(--mm-sans,Arial);letter-spacing:.04em;position:relative;border-radius:2px} .mmgp__g svg{width:100%;max-width:38px;height:auto} .mmgp__g.is-ours{color:var(--mm-navy,#0C1C2E)} .mmgp__g::after{content:\"\";position:absolute;left:0;right:0;bottom:-6px;height:3px;background:var(--mm-line,rgba(150,118,90,.22))} .mmgp__g.is-ours::after{background:var(--mm-navy,#0C1C2E)} .mmgp__g[aria-pressed=\"true\"]{background:var(--mm-sand,#EDE5D7)} .mmgp__g:focus-visible{outline:1px solid var(--mm-mocha,#6B5341);outline-offset:2px} .mmgp__bands{display:grid;gap:2px;margin-top:6px;font-size:11px;line-height:1.3;color:var(--mm-mocha,#6B5341);text-align:center} .mmgp__key{display:flex;align-items:center;gap:8px;font-size:12px;color:var(--mm-mocha,#6B5341);margin-top:4px} .mmgp__key i{display:inline-block;width:22px;height:3px;background:var(--mm-navy,#0C1C2E)} .mmgp__tip{border-left:2px solid var(--mm-navy,#0C1C2E);padding:2px 0 2px 14px;min-height:3.4em} .mmgp__tip b{font-weight:500} .mmgp__ours{background:var(--mm-sand,#EDE5D7);padding:14px 16px;font-size:14px} .mmgp__ours b{font-weight:500} .mmgp__note{font-size:13px;color:var(--mm-mocha,#6B5341)} html.mmgp-lock,html.mmgp-lock body{overflow:hidden} html body .mm-spec .mm-spec__row dt .mm-spec__i{margin-left:8px!important} html body .mm-spec .mm-spec__tip{font-size:13px!important;line-height:1.55!important;font-family:var(--mm-sans,Montserrat,Arial,sans-serif)!important} html body .mm-spec .mm-spec__tip.mmgp-mini{top:auto!important;bottom:calc(100% + 8px)!important;width:320px;padding:14px 16px 12px;display:none} html body .mm-spec .mm-spec__tip.mmgp-mini:not([hidden]){display:grid;gap:10px} html body main .mm-spec .mmgp-mini__h{font:500 10px/1.4 var(--mm-sans,Arial)!important;letter-spacing:.16em!important;text-transform:uppercase;color:var(--mm-mocha,#6B5341)} html body main .mm-spec .mmgp-mini__h b{font:inherit!important;letter-spacing:inherit!important;color:var(--mm-navy,#0C1C2E)} .mmgp-mini__row{display:grid;grid-auto-flow:column;grid-auto-columns:1fr;gap:1px} html body main .mm-spec .mmgp-mini__g, html body main .mm-spec .mmgp-mini__g span{font:500 10px/1 var(--mm-sans,Arial)!important;letter-spacing:0!important} .mmgp-mini__g{display:grid;justify-items:center;gap:3px;color:var(--mm-accent,#96765A);padding-bottom:5px;border-bottom:2px solid var(--mm-line,rgba(150,118,90,.22))} .mmgp-mini__g svg{width:100%;max-width:24px;height:auto} .mmgp-mini__g.is-ours{color:var(--mm-navy,#0C1C2E);border-bottom-color:var(--mm-navy,#0C1C2E)} .mmgp-mini__g.is-this svg{background:var(--mm-sand,#EDE5D7);border-radius:50%} html body main .mm-spec .mmgp-mini__p{font-size:12px!important;line-height:1.5!important;letter-spacing:0!important;color:var(--mm-navy,#0C1C2E)} html body main .mm-spec .mmgp-mini__more{font:500 10px/1.4 var(--mm-sans,Arial)!important;letter-spacing:.16em!important;text-transform:uppercase;color:var(--mm-mocha,#6B5341)} @media (hover: hover) and (pointer: fine){html body .mm-spec .mm-spec__i:hover + .mm-spec__tip.mmgp-mini{display:grid}}";
  const st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  const box = document.createElement('div');
  box.className = 'mmgp';
  box.innerHTML = '<div class="mmgp__bg" data-mmgp-close></div><div class="mmgp__p" role="dialog" aria-modal="true" aria-labelledby="mmgp-t" tabindex="-1"></div>';
  document.body.appendChild(box);
  const pane = box.querySelector('.mmgp__p');
  let lastBtn = null;

  function open(kind, value, btn) {
    if (!G[kind]) return;
    ORIGIN = originOf();
    lastBtn = btn || null;
    const I = info(kind, value), d = I.d, minI = I.minI, maxI = I.maxI, raw = I.raw, sel = I.sel;
    const shown = raw.replace(/\+$/, ' or better').replace(/\s*[–-]\s*/, ' to ');
    const tiles = d.grades.map((g, i) => '<button type="button" class="mmgp__g' + (i >= minI && i <= maxI ? ' is-ours' : '') + '" data-g="' + g + '" aria-pressed="' + (g === sel) + '">' + gem(kind, g, i) + '<span>' + g + '</span></button>').join('');
    const bands = d.bands.length ? '<div class="mmgp__bands" style="grid-template-columns:' + d.bands.map((b) => b[1] + 'fr').join(' ') + '">' + d.bands.map((b) => '<span>' + b[0] + '</span>').join('') + '</div>' : '';
    pane.innerHTML =
      '<button type="button" class="mmgp__x" data-mmgp-close aria-label="Close">×</button>' +
      '<p class="mmgp__eye">Diamond detail</p><h2 id="mmgp-t">' + d.title + '</h2><p>' + I.body + '</p>' +
      (raw ? '<div class="mmgp__this"><span>This piece</span><b>' + shown + '</b></div>' : '') +
      '<div class="mmgp__scale"><div class="mmgp__row" role="group" aria-label="' + d.title + ' grades">' + tiles + '</div>' + bands +
      '<div class="mmgp__key"><i></i>The grades we set</div></div>' +
      '<p class="mmgp__tip" aria-live="polite"><b>' + sel + '.</b> ' + tipOf(d, sel) + '</p>' +
      '<p class="mmgp__ours"><b>' + (d.promise[ORIGIN] ? 'Our standard.' : 'This piece.') + '</b> ' + I.promise + '</p>' +
      '<p class="mmgp__note">Tap any grade to see what it means.</p>';
    pane.querySelectorAll('.mmgp__g').forEach((b) => b.addEventListener('click', () => {
      pane.querySelectorAll('.mmgp__g').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      pane.querySelector('.mmgp__tip').innerHTML = '<b>' + b.dataset.g + '.</b> ' + tipOf(d, b.dataset.g);
    }));
    box.classList.add('is-open');
    document.documentElement.classList.add('mmgp-lock');
    requestAnimationFrame(() => requestAnimationFrame(() => { box.classList.add('is-in'); pane.focus({ preventScroll: true }); }));
  }
  function close() {
    if (!box.classList.contains('is-open')) return;
    box.classList.remove('is-in');
    document.documentElement.classList.remove('mmgp-lock');
    setTimeout(() => box.classList.remove('is-open'), 300);
    if (lastBtn) lastBtn.focus({ preventScroll: true });
  }
  box.addEventListener('click', (e) => { if (e.target.closest('[data-mmgp-close]')) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  const kindOf = (row) => {
    const t = ((row.querySelector('dt') || {}).textContent || '').trim().toLowerCase();
    if (t.indexOf('color') === 0) return 'color';
    if (t.indexOf('clarity') === 0) return 'clarity';
    if (t.indexOf('polish') === 0) return 'polish';
    return '';
  };
  /* small hover card: the scale at a glance, then a click opens the full panel */
  function mini(kind, value) {
    ORIGIN = originOf();
    const I = info(kind, value), d = I.d, minI = I.minI, maxI = I.maxI, raw = I.raw, sel = I.sel;
    const row = d.grades.map((g, i) => '<span class="mmgp-mini__g' + (i >= minI && i <= maxI ? ' is-ours' : '') + (g === sel ? ' is-this' : '') + '">' + gem(kind, g, i) + '<span>' + (g === 'Very Good' ? 'V. Good' : g) + '</span></span>').join('');
    return '<span class="mmgp-mini__h">' + d.title + ' · <b>' + raw.replace(/\+$/, ' or better').replace(/\s*[–-]\s*/, ' to ') + '</b></span><span class="mmgp-mini__row">' + row + '</span><span class="mmgp-mini__p">' + I.promise + '</span><span class="mmgp-mini__more">Click the (i) for the full scale</span>';
  }
  spec.querySelectorAll('.mm-spec__row').forEach((row) => {
    const kind = kindOf(row); if (!kind) return;
    const dt = row.querySelector('dt');
    let b = row.querySelector('.mm-spec__i');
    if (!b) {
      b = document.createElement('button');
      b.type = 'button'; b.className = 'mm-spec__i'; b.setAttribute('aria-label', 'About ' + kind); b.textContent = 'i';
      dt.appendChild(b);
    }
    let tip = b.nextElementSibling && b.nextElementSibling.classList.contains('mm-spec__tip') ? b.nextElementSibling : null;
    if (!tip) { tip = document.createElement('span'); tip.className = 'mm-spec__tip'; tip.hidden = true; b.after(tip); }
    tip.classList.add('mmgp-mini'); tip.setAttribute('aria-hidden', 'true');
    tip.innerHTML = mini(kind, ((row.querySelector('dd') || {}).textContent || '').trim());
  });
  /* capture: take over (i) clicks on the three grade rows before the tooltip handler */
  spec.addEventListener('click', (e) => {
    const b = e.target.closest('.mm-spec__i'); if (!b) return;
    const row = b.closest('.mm-spec__row'); const kind = row && kindOf(row);
    if (!kind) return;
    e.preventDefault(); e.stopPropagation();
    b.setAttribute('aria-haspopup', 'dialog');
    open(kind, ((row.querySelector('dd') || {}).textContent || '').trim(), b);
  }, true);
  window.mmGradePanel = open;
  // v1.4: rebuild the hover cards after natural mode changes the grades
  window.mmGradeRefresh = () => {
    ORIGIN = originOf();
    spec.querySelectorAll('.mm-spec__row').forEach((row) => {
      const kind = kindOf(row); if (!kind) return;
      const tip = row.querySelector('.mm-spec__tip.mmgp-mini');
      if (tip) tip.innerHTML = mini(kind, ((row.querySelector('dd') || {}).textContent || '').trim());
    });
  };
})();
